"use strict";

require("core-js/modules/es.promise.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreSaga = coreSaga;
exports.tryRequest = tryRequest;
var _effects = require("redux-saga/effects");
var _actions = require("../../../utils/actions");
var _functions = require("../../../utils/functions");
var _sockets = require("../../../entities/sockets");
var _translations = require("../../../entities/translations");
var _devices = require("../../../entities/devices");
function* coreSaga() {
  yield (0, _effects.all)([(0, _translations.translationSaga)(), (0, _devices.devicesSaga)(), (0, _sockets.socketSaga)()]);
}
function* tryRequest(type, socketRequest) {
  try {
    while (true) {
      let response = yield (0, _effects.take)(socketRequest);
      (0, _functions.throwErrorIfIsNotCondition)(Boolean(response === null || response === void 0 ? void 0 : response.data), 'Empty response data');
      const responseData = yield (0, _effects.call)(() => JSON.parse(response.data));
      yield handleResponse(type, responseData);
    }
  } catch (error) {
    yield (0, _effects.call)(() => console.log('catch', error, type));
    yield (0, _effects.put)((0, _actions.requestError)(type, {
      message: error.message
    }));
  }
}
function handleResponse(type, responseData) {
  let payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function* () {
    yield (0, _effects.put)((0, _actions.requestSuccess)(type, payload ? {
      data: responseData,
      requestData: payload
    } : responseData));
  }();
}